import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import * as React from 'react';

import { MuiBaseColorEnum } from '../../../types/shell';
import { DialogCloseButton } from '../_controls_';

interface IProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  cancelButtonColor?: MuiBaseColorEnum;
  confirmButtonColor?: MuiBaseColorEnum;
  isLoading?: boolean;
  reverseActions?: boolean;
}

export const ConfirmationDialog: React.FC<IProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmButtonText = 'Confirm',
  cancelButtonText = 'Cancel',
  cancelButtonColor,
  isLoading = false,
  confirmButtonColor,
  reverseActions = false,
}) => {
  return (
    <Dialog open={open} onClose={isLoading ? undefined : onClose}>
      <DialogTitle variant="h6" sx={{ pb: 2 }}>
        {title}
      </DialogTitle>
      <DialogCloseButton onClick={onClose} dataAction="close_confirmation_dialog" disabled={isLoading} />
      <DialogContent sx={{ pt: 0, position: 'relative' }}>
        {isLoading && (
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1,
              bgcolor: 'background.paper',
              opacity: 0.8,
            }}
          >
            <CircularProgress size={32} />
          </Box>
        )}
        <DialogContentText color="text.secondary" variant="body1">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'flex-end', px: 3, pb: 3, pt: 1 }}>
        <Button
          variant="text"
          size="small"
          onClick={reverseActions ? onConfirm : onClose}
          color={reverseActions ? confirmButtonColor : cancelButtonColor}
          disabled={isLoading}
          sx={{ fontSize: 14 }}
        >
          {reverseActions ? confirmButtonText : cancelButtonText}
        </Button>
        <Button
          variant="contained"
          size="small"
          onClick={reverseActions ? onClose : onConfirm}
          autoFocus
          disabled={isLoading}
          color={reverseActions ? cancelButtonColor : confirmButtonColor}
          sx={{ fontSize: 14 }}
        >
          {reverseActions ? cancelButtonText : confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
